import { atom } from 'jotai'

export const loadUuidState = atom<boolean>(false)
export const loadProductCreditState = atom<boolean>(false)

type TImportLoadState = {
    dictionary: boolean
    productCredit: boolean
    product: boolean
    period: boolean
    orderDetail: boolean
    addressHistory: boolean
}
export const importLoadState = atom<TImportLoadState>({
    dictionary: false,
    productCredit: false,
    product: false,
    period: false,
    orderDetail: false,
    addressHistory: false
})

type TPaymentProcessState = {
    orderProcessing: number
    paymentProcessing: number
    logProcessing: number
}
export const paymentProcessState = atom<TPaymentProcessState>({
    orderProcessing: 0,
    paymentProcessing: 0,
    logProcessing: 0
})

export const isReadyState = atom<boolean>(false)
export const isProdcutCreditReadyState = atom<boolean>(false)
export const isFetchedAddressHistoryState = atom<boolean>(false)
export const isAllowedAddressHistoryState = atom<boolean>(false)
